// extracted by mini-css-extract-plugin
export default {"CardImg":"Recipes_CardImg__8St5m","CardBody":"Recipes_CardBody__G751U","RecipeCol":"Recipes_RecipeCol__T1Iqp","RecipeCard":"Recipes_RecipeCard__sDbPy"};